/* Lune Mode — lm-cart.js
   Custom cart-drawer enhancements on top of Symmetry's native cart-form engine.
   - Progress-discount bar (tiers: 2=10% 3=15% 4=20% 5=25%), localized fr/en/hu
   - "Others also bought" recommendations slider (+Add)
   NO shipping protection. NO sale/compare-at badges.
   Hooks native events: on:cart:change (cart mutated) + on:cart:after-merge (drawer re-rendered). */
(function () {
  if (window.__lmCart) return;
  window.__lmCart = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var recsKey = '';
  var recsBusy = false;

  /* ---------- shipping protection ---------- */
  var PROTECT = 57217889468760;        // variant id
  var PROTECT_PID = 15739201388888;    // product id (excluded from recs)
  var OPTOUT = 'lune_protect_off';
  var pLock = false;                   // guards against mutate-loop during add/remove
  function wantsProtect() { try { return localStorage.getItem(OPTOUT) !== '1'; } catch (e) { return true; } }
  function setOptout(off) { try { off ? localStorage.setItem(OPTOUT, '1') : localStorage.removeItem(OPTOUT); } catch (e) {} }
  function protectQty(cart) {
    var q = 0; ((cart && cart.items) || []).forEach(function (i) { if (i.variant_id === PROTECT || i.id === PROTECT) q += i.quantity; }); return q;
  }
  function realCount(cart) { return Math.max(0, ((cart && cart.item_count) || 0) - protectQty(cart)); }
  function mutateProtect(qty) {
    pLock = true;
    var url = qty > 0 ? (root + 'cart/add.js') : (root + 'cart/change.js');
    var body = qty > 0 ? { id: PROTECT, quantity: 1 } : { id: String(PROTECT), quantity: 0 };
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function () { return getJSON(root + 'cart.js'); })
      .then(function (cart) { pLock = false; if (cart) cart.__mutated = true; return cart; })
      .catch(function () { pLock = false; });
  }
  // Reconcile protection vs the user's opt-in/out and whether real items exist.
  function ensureProtect(cart) {
    if (pLock) return Promise.resolve(cart);
    var has = protectQty(cart) > 0;
    var real = realCount(cart);
    if (has && real <= 0) return mutateProtect(0);                 // no real items -> drop leftover
    if (!has && real > 0 && wantsProtect()) return mutateProtect(1); // auto-add (default ON)
    if (has && !wantsProtect()) return mutateProtect(0);            // user opted out
    return Promise.resolve(cart);
  }
  function setProtectUI(cart) {
    var d = document.querySelector('.js-cart-drawer'); if (!d) return;
    var cb = d.querySelector('[data-lm-protect-toggle]');
    if (cb) cb.checked = protectQty(cart) > 0;
    // keep the displayed price presentment-accurate when protection is in the cart
    var priceEl = d.querySelector('[data-lm-protect-price]');
    if (priceEl) {
      var pp = 0; ((cart && cart.items) || []).forEach(function (i) { if (i.variant_id === PROTECT || i.id === PROTECT) pp = i.price; });
      if (pp) priceEl.textContent = money(pp);
    }
  }

  /* ---------- locale + money ---------- */
  function locale() {
    var l = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    if (l.indexOf('fr') === 0) return 'fr';
    if (l.indexOf('hu') === 0) return 'hu';
    if (l.indexOf('it') === 0) return 'it';
    if (l.indexOf('es') === 0) return 'es';
    if (l.indexOf('cs') === 0) return 'cs';
    return 'en';
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    // CZK must match what Liquid renders (snippets/lm-money.liquid): "1 048 Kč".
    // Intl would give "Kč 1.048,00" here, which is neither Czech nor consistent with the page.
    if (cur === 'CZK') {
      var whole = Math.floor(cents / 100), frac = cents % 100;
      var out = whole.toLocaleString('cs-CZ').replace(/\s/g, '\u00a0');
      if (frac) out += ',' + String(frac).padStart(2, '0');   // Liquid keeps real cents, drops ",00"
      return out + '\u00a0K\u010d';
    }
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (e) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); } catch (e2) { return (cents / 100).toFixed(2); } }
  }
  // /products.json returns prices as decimal strings ("19.95"); recommendations API returns cents.
  function toCents(x) { if (x == null) return 0; return (typeof x === 'string') ? Math.round(parseFloat(x) * 100) : x; }
  function recPriceHtml(price, cmp) {
    return (cmp && cmp > price)
      ? '<span class="lm-rec__was">' + money(cmp) + '</span><span class="lm-rec__now">' + money(price) + '</span>'
      : '<span class="lm-rec__now">' + money(price) + '</span>';
  }

  /* ---------- progress copy (mirrors section liquid) ---------- */
  function nextOff(qty) {
    if (qty <= 1) return 10;
    if (qty === 2) return 15;
    if (qty === 3) return 20;
    return 25;
  }
  function progressHtml(qty) {
    var L = locale();
    if (qty >= 5) {
      if (L === 'fr') return '🎉 Vous avez débloqué <strong>25% de réduction</strong> !';
      if (L === 'hu') return '🎉 Megnyitottad a <strong>25% kedvezményt</strong>!';
      if (L === 'it') return '🎉 Hai sbloccato il <strong>25% di sconto</strong>!';
      if (L === 'es') return '🎉 ¡Has desbloqueado un <strong>25% de descuento</strong>!';
      if (L === 'cs') return '🎉 Odemkli jste <strong>slevu 25%</strong>!';
      return "🎉 You've unlocked <strong>25% off</strong>!";
    }
    var n = nextOff(qty);
    if (L === 'fr') return 'Ajoutez <strong>1 article</strong> et obtenez <strong>' + n + '% de réduction</strong>';
    if (L === 'hu') return 'Adj hozzá <strong>1 terméket</strong> és kapj <strong>' + n + '% kedvezményt</strong>';
    if (L === 'it') return 'Aggiungi <strong>1 altro articolo</strong> e ottieni il <strong>' + n + '% di sconto</strong>';
    if (L === 'es') return 'Añade <strong>1 artículo más</strong> y consigue un <strong>' + n + '% de descuento</strong>';
    if (L === 'cs') return 'Přidejte <strong>ještě 1 kus</strong> a získejte <strong>slevu ' + n + '%</strong>';
    return 'Add <strong>1 more</strong> and get <strong>' + n + '% off</strong>';
  }
  function progressPct(qty) {
    if (qty <= 0) return 0;
    if (qty === 1) return 10;
    if (qty === 2) return 20;
    if (qty === 3) return 40;
    if (qty === 4) return 60;
    return 100;
  }

  function updateProgress(cart) {
    var d = document.querySelector('.js-cart-drawer'); if (!d) return;
    var wrap = d.querySelector('.lm-prog'); if (!wrap) return;
    var qty = realCount(cart);
    var msg = wrap.querySelector('.lm-prog__msg');
    if (msg) msg.innerHTML = progressHtml(qty);
    var fill = wrap.querySelector('.lm-prog__fill');
    if (fill) fill.style.width = progressPct(qty) + '%';
    var nodes = wrap.querySelectorAll('.lm-prog__node');
    var labels = wrap.querySelectorAll('.lm-prog__labels span');
    [2, 3, 4, 5].forEach(function (tier, i) {
      if (nodes[i]) nodes[i].classList.toggle('is-on', qty >= tier);
      if (labels[i]) labels[i].classList.toggle('is-on', qty >= tier);
    });
  }

  /* ---------- recommendations ---------- */
  function recsTitle() {
    var L = locale();
    if (L === 'fr') return 'Souvent achetés ensemble';
    if (L === 'hu') return 'Gyakran együtt vásárolt';
    if (L === 'it') return 'Spesso acquistati insieme';
    if (L === 'es') return 'Comprados juntos habitualmente';
    if (L === 'cs') return 'Často nakupované společně';
    return 'Others also bought';
  }
  function addLabel() {
    var L = locale();
    return L === 'fr' ? '+ Ajouter' : L === 'hu' ? '+ Hozzáadás'
      : L === 'it' ? '+ Aggiungi' : L === 'es' ? '+ Añadir'
      : L === 'cs' ? '+ Přidat' : '+ Add';
  }
  function getJSON(url) { return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function renderRecs(cart) {
    var d = document.querySelector('.js-cart-drawer'); if (!d) return;
    var box = d.querySelector('[data-lm-recs]'); if (!box) return;
    var items = ((cart && cart.items) || []).filter(function (i) { return i.product_id !== PROTECT_PID; });
    if (!items.length) { box.hidden = true; return; }
    var inCart = {}; items.forEach(function (i) { inCart[i.product_id] = true; });
    var key = items.map(function (i) { return i.product_id; }).join(',');
    if (key === recsKey && box.dataset.lmFilled === '1') { box.hidden = false; return; }
    if (recsBusy) return;
    recsBusy = true;

    var pid = items[0].product_id;
    var url = root + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related';
    getJSON(url).then(function (data) {
      var prods = (data && data.products) || [];
      prods = prods.filter(function (p) { return !inCart[p.id] && p.available !== false; });
      if (!prods.length) {
        // fallback: popular products
        return getJSON(root + 'products.json?limit=12').then(function (d2) {
          var pp = ((d2 && d2.products) || []).filter(function (p) { return !inCart[p.id] && p.available !== false; });
          return pp;
        });
      }
      return prods;
    }).then(function (prods) {
      prods = (prods || []).slice(0, 8);
      var list = box.querySelector('[data-lm-recs-list]');
      if (!prods.length) { box.hidden = true; recsBusy = false; return; }
      list.innerHTML = prods.map(function (p) { return recCard(p); }).join('');
      box.dataset.lmFilled = '1';
      recsKey = key;
      box.hidden = false;
      bindRecs(box);
      recsBusy = false;
    }).catch(function () { recsBusy = false; });
  }

  function firstAvailableVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) { if (vs[i].available !== false) return vs[i]; }
    return vs[0];
  }
  function imgOf(p) {
    if (p.featured_image) return p.featured_image;
    if (p.images && p.images.length) return (typeof p.images[0] === 'string') ? p.images[0] : p.images[0].src;
    if (p.image && p.image.src) return p.image.src;
    return '';
  }
  function recCard(p) {
    var v = firstAvailableVariant(p); if (!v) return '';
    var img = imgOf(p);
    if (img && img.indexOf('?') === -1) img = img + '?width=140';
    var price = toCents(v.price != null ? v.price : p.price);
    var cmp = toCents(v.compare_at_price);
    var variants = (p.variants || []).filter(function (x) { return x.available !== false; });
    var sel = '';
    if (variants.length > 1) {
      sel = '<select class="lm-rec__variant" data-lm-rec-variant>' + variants.map(function (x) {
        return '<option value="' + x.id + '" data-price="' + toCents(x.price) + '" data-cmp="' + toCents(x.compare_at_price) + '">' + (x.title || '').replace(/</g, '') + '</option>';
      }).join('') + '</select>';
    }
    var title = (p.title || '').replace(/</g, '&lt;');
    var url = (p.url || (root + 'products/' + p.handle));
    return '<div class="lm-rec" data-lm-rec data-vid="' + v.id + '">' +
      '<div class="lm-rec__imgwrap"><a href="' + url + '">' + (img ? '<img class="lm-rec__img" src="' + img + '" alt="" loading="lazy">' : '') + '</a></div>' +
      '<div class="lm-rec__body">' +
        '<a class="lm-rec__title" href="' + url + '">' + title + '</a>' +
        '<div class="lm-rec__price" data-lm-rec-price>' + recPriceHtml(price, cmp) + '</div>' +
        '<div class="lm-rec__actions">' + sel + '<button type="button" class="lm-rec__add" data-lm-rec-add>' + addLabel() + '</button></div>' +
      '</div></div>';
  }

  function bindRecs(box) {
    var list = box.querySelector('[data-lm-recs-list]');
    box.querySelectorAll('[data-lm-rec-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var card = sel.closest('[data-lm-rec]');
        var opt = sel.options[sel.selectedIndex];
        card.setAttribute('data-vid', opt.value);
        var pr = card.querySelector('[data-lm-rec-price]');
        if (pr) pr.innerHTML = recPriceHtml(parseInt(opt.dataset.price || 0, 10), parseInt(opt.dataset.cmp || 0, 10));
      });
    });
    box.querySelectorAll('[data-lm-rec-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-lm-rec]');
        var vid = card.getAttribute('data-vid'); if (!vid) return;
        btn.disabled = true;
        fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        }).then(function (r) { return r.json(); }).then(function () {
          // let Symmetry's cart-form re-fetch + merge the drawer, and header update
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }).catch(function () { btn.disabled = false; });
      });
    });
    // arrows + drag
    var prev = box.querySelector('[data-lm-recs-prev]');
    var next = box.querySelector('[data-lm-recs-next]');
    function step() { var c = list.querySelector('.lm-rec'); return c ? c.getBoundingClientRect().width + 10 : 200; }
    if (prev) prev.onclick = function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); };
    if (next) next.onclick = function () { list.scrollBy({ left: step(), behavior: 'smooth' }); };
    enableDrag(list);
  }

  function enableDrag(el) {
    if (!el || el.__lmDrag) return; el.__lmDrag = true;
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', function (e) { down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; });
    el.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 3) moved = true; el.scrollLeft = sl - dx; });
    function up() { down = false; }
    el.addEventListener('pointerup', up); el.addEventListener('pointerleave', up);
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ---------- refresh cycle ---------- */
  function updateCheckout(cart) {
    var d = document.querySelector('.js-cart-drawer'); if (!d) return;
    var el = d.querySelector('[data-lm-co-price]');
    if (el && cart && typeof cart.total_price === 'number') el.textContent = money(cart.total_price);
  }

  function paint(cart) {
    updateProgress(cart);
    updateCheckout(cart);
    renderRecs(cart);
    setProtectUI(cart);
  }

  function refresh() {
    getJSON(root + 'cart.js').then(function (cart) {
      return ensureProtect(cart).then(function (res) {
        var c = (res && res.items) ? res : cart;
        paint(c);
        // a protection add/remove went through a raw fetch — re-render Symmetry's
        // drawer so the protection line is filtered out + subtotal/total update.
        if (res && res.__mutated) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      });
    }).catch(function () {});
  }

  // toggle (event-delegated so it survives drawer re-renders)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-lm-protect-toggle]')) return;
    setOptout(!t.checked);
    refresh();
  });

  document.addEventListener('on:cart:change', refresh);
  document.addEventListener('on:cart:after-merge', refresh);
  document.addEventListener('on:cart:add', refresh);
  // also refresh when the drawer opens (recs/progress correct even without a mutation)
  document.addEventListener('dispatch:cart-drawer:open', function () { setTimeout(refresh, 60); });

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
